import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // DEFINITIONS: Match only core BFF domains exactly at the start or via specific host
  const isBff = req.url.startsWith('https://api.cor.mer.eco') || req.url.startsWith('https://dev.api.cor.mer.eco');
  const isCloudFunction = req.url.includes('cloudfunctions.net');

  // PATH 1: CloudFunctions - NO LOGOUT LOGIC, USES FIREBASE TOKEN
  if (isCloudFunction) {
    console.log(`[AuthInterceptor] CloudFunction (PROTECTED): ${req.url}`);
    return from(authService.authFirebase.currentUser?.getIdToken() || Promise.resolve(null)).pipe(
      switchMap(token => {
        const cloned = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
        return next(cloned).pipe(
          catchError(err => {
            if (err.status === 401) {
              console.warn(`[AuthInterceptor] CloudFunction 401 ERROR (STAYING LOGGED IN): ${req.url}`);
            }
            return throwError(() => err);
          })
        );
      })
    );
  }

  // PATH 2: BFF - USES MSAL TOKEN, DOES NOT LOG OUT ON API FAILURES
  if (isBff) {
    console.log(`[AuthInterceptor] BFF Request: ${req.url}`);
    return from(authService.acquireToken()).pipe(
      catchError(err => {
        console.error(`[AuthInterceptor] Token acquisition failed for: ${req.url}`, err);
        return throwError(() => err);
      }),
      switchMap(token => {
        const cloned = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
        return next(cloned).pipe(
          catchError(err => {
            console.warn(`[AuthInterceptor] BFF Request error (${err.status}): ${req.url}`, err);
            return throwError(() => err);
          })
        );
      })
    );
  }

  // PATH 3: ALL OTHERS - JUST PASS THROUGH
  console.log(`[AuthInterceptor] External Request (Pass-through): ${req.url}`);
  return next(req);
};
